// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1Dt0P","content":"Consent_content__16bBO","footer":"Consent_footer__2VTi5"};